import { createElement } from 'react';

import {
  createFrontendPlugin,
  PageBlueprint,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import MemoryIcon from '@mui/icons-material/Memory';

import { rootRouteRef } from './routes';

const aiToolsPage = PageBlueprint.make({
  name: 'ai-tools',
  params: {
    path: '/ai-tools',
    title: 'AI Inventory',
    icon: createElement(MemoryIcon),
    routeRef: rootRouteRef,
    loader: async () => {
      const { AIToolsExplorerPage } = await import(
        './components/AIToolsExplorer/AIToolsExplorerPage'
      );
      return createElement(AIToolsExplorerPage);
    },
  },
});

export const aiToolsPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'ai-tools-frontend',
  extensions: [aiToolsPage],
  routes: {
    root: rootRouteRef,
  },
});
